
import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { injectIntl, FormattedMessage } from 'react-intl'
import { Game } from '../../Core'
import * as tutorialActions from '../tutorial.actions'

const TutorialLastTurnPopup = ({ removePopup, changeTurn }) => (
  <div className="popup--game">
    <div className="popup--box">
      <div className="popup--box__canvas">
        <div className="popup--heading">
          <FormattedMessage id={'popups.lastTurnTutorial.title'} />
        </div>
        <div className="popup--text">
          <FormattedMessage id={'popups.lastTurnTutorial.text'} />
        </div>
        <div className="popup--buttons">
          <div
            onClick={() => {
              removePopup('tutorial_last_turn_popup')
              changeTurn()
            }}
            className="btn--shape shape--blue"
          >
            <div className="btn--shape__canvas">
              <FormattedMessage id={'popups.accept'} />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

const mapDispatchToProps = (dispatch) => {
  return {
    removePopup: bindActionCreators(Game.actions.removePopup, dispatch),
    changeTurn: bindActionCreators(tutorialActions.nextTurn, dispatch),
  }
}

TutorialLastTurnPopup.propTypes = {
  removePopup: PropTypes.func,
  changeTurn: PropTypes.func,
}

export default connect(null, mapDispatchToProps)(injectIntl(TutorialLastTurnPopup))
